import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProjectsPage, type ProjectsSearchState } from '../features/projects/projects-page';

const ProjectsSearchSchema = z.object({
  order: z.enum(['asc', 'desc']).catch('desc'),
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  search: z.string().trim().max(200).optional().catch(undefined),
  sort: z.enum(['name', 'updatedAt']).catch('updatedAt'),
  status: z.enum(['active', 'archived']).optional().catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/projects/')({
  component: ProjectsRoute,
  validateSearch: zodValidator(ProjectsSearchSchema),
});

function ProjectsRoute() {
  const { companySlug } = Route.useParams();
  const searchState: ProjectsSearchState = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ProjectsPage
      companySlug={companySlug}
      onClearFilters={() =>
        void navigate({
          search: (previous) => ({ ...previous, page: 1, search: undefined, status: undefined }),
        })
      }
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      onSearchChange={(search) =>
        void navigate({
          replace: true,
          search: (previous) => ({ ...previous, page: 1, search }),
        })
      }
      onSortChange={(sort, order) =>
        void navigate({ search: (previous) => ({ ...previous, order, page: 1, sort }) })
      }
      onStatusChange={(status) =>
        void navigate({ search: (previous) => ({ ...previous, page: 1, status }) })
      }
      searchState={searchState}
    />
  );
}
